import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import FullscreenLoading from 'app/components/UI/FullscreenLoading';

import useAuthContext from 'app/hooks/useAuthContext';

function AuthLayout() {
  const { isValidatingAuth, isFetchingIndividual } = useAuthContext();

  if (isValidatingAuth || isFetchingIndividual) {
    return <FullscreenLoading />;
  }

  return (
    <Suspense fallback={<FullscreenLoading />}>
      <Outlet />
    </Suspense>
  );
}

export default AuthLayout;
